/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateCashbackInput = {|
  clientMutationId?: ?string,
  date: string,
  fastCashId: string,
  place: string,
  purchaseAmount: string,
  storeId: string,
|};
export type createCashbackMutationVariables = {|
  input: CreateCashbackInput
|};
export type createCashbackMutationResponse = {|
  +createCashback: ?{|
    +cashback: ?{|
      +id: string
    |},
    +errorMessage: ?string,
  |}
|};
export type createCashbackMutation = {|
  variables: createCashbackMutationVariables,
  response: createCashbackMutationResponse,
|};
*/


/*
mutation createCashbackMutation(
  $input: CreateCashbackInput!
) {
  createCashback(input: $input) {
    cashback {
      id
    }
    errorMessage
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCashbackInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCashbackPayload",
    "kind": "LinkedField",
    "name": "createCashback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Cashback",
        "kind": "LinkedField",
        "name": "cashback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createCashbackMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createCashbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createCashbackMutation",
    "operationKind": "mutation",
    "text": "mutation createCashbackMutation(\n  $input: CreateCashbackInput!\n) {\n  createCashback(input: $input) {\n    cashback {\n      id\n    }\n    errorMessage\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'da99fb67b6d61069eeb4d8fb878899ee';

module.exports = node;
